import {Component, OnInit, Input, Inject} from 'ng-metadata/core';
import {ProgressCheckBoxService} from './progressCheckBox.service';

@Component({
    selector: 'prm-progress-checkbox',
    templateUrl: 'components/search/fullView/ngrs/progressBar/progressCheckBox/progress-check-box.html',
})

export class PrmProgressCheckBox implements OnInit{
    
    @Input() status:Object;

    constructor(private progressCheckBoxService: ProgressCheckBoxService,
        @Inject('$translate') private $translate: ng.translate.ITranslateService) {
    }

    ngOnInit() {
    }

    public isChecked(){
        if(this.status.checked){
            return true;
        }
        return false;
    }

    public getStatusLabel(){
        if(this.status.label === "REQUESTED"){
            return "nui.ngrs.request.status.requested";
        }
        else if(this.status.label === "IN_PROCESS_BY_LENDER"){
            return "nui.ngrs.request.status.in_process";
        }
        else if(this.status.label === "SHIPPED"){
            return "nui.ngrs.request.status.shipped";
        }
        else if(this.status.label === "RECEIVED"){
            return "nui.ngrs.request.status.received";
        }
        else if(this.status.label === "SENT"){
            return "nui.ngrs.request.status.sent";
        }
        return "nui.ngrs.request.status.received";
    }

    public getStatusAriaLable(){
        let aria = this.$translate.instant("nui.ngrs.aria.request.status");
        if(this.status.label === "REQUESTED"){
            aria = this.$translate.instant("nui.ngrs.request.status.requested");
        }
        else if(this.status.label === "IN_PROCESS_BY_LENDER"){
            aria = this.$translate.instant("nui.ngrs.request.status.in_process");
        }
        else if(this.status.label === "SHIPPED"){
            aria = this.$translate.instant("nui.ngrs.request.status.shipped");
        }
        else if(this.status.label === "RECEIVED"){
            aria = this.$translate.instant("nui.ngrs.request.status.received");
        }
        else if(this.status.label === "SENT"){
            aria = this.$translate.instant("nui.ngrs.request.status.sent");
        }

        if(this.status.checked){
            aria += " " + this.$translate.instant("nui.ngrs.aria.request.status.done");
        }
        return aria;
    }

    public getDate(){
        if(this.status.date){
            return this.status.date;
        }
        return " ";
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/progressBar/progressCheckBox/progressCheckBox.directive.ts